export var LAYOUT_TYPE = /*#__PURE__*/function (LAYOUT_TYPE) {
  LAYOUT_TYPE["SINGLE_COL"] = "singleColumn";
  LAYOUT_TYPE["TWO_COLS_EQUAL"] = "twoColumnsEqual";
  LAYOUT_TYPE["THREE_COLS_EQUAL"] = "threeColumnsEqual";
  LAYOUT_TYPE["LEFT_SIDEBAR"] = "twoColumnsLeftSidebar";
  LAYOUT_TYPE["RIGHT_SIDEBAR"] = "twoColumnsRightSidebar";
  LAYOUT_TYPE["THREE_WITH_SIDEBARS"] = "threeColumnsWithSidebars ";
  LAYOUT_TYPE["FOUR_COLS_EQUAL"] = "fourColumnsEqual";
  LAYOUT_TYPE["FIVE_COLS_EQUAL"] = "fiveColumnsEqual";
  return LAYOUT_TYPE;
}({});
export var SMART_LINK_TYPE = /*#__PURE__*/function (SMART_LINK_TYPE) {
  SMART_LINK_TYPE["INLINE_CARD"] = "inline";
  SMART_LINK_TYPE["BLOCK_CARD"] = "block";
  SMART_LINK_TYPE["URL"] = "url";
  return SMART_LINK_TYPE;
}({});